u<template>
  <div class="dashboard">
    <div class="banner">
      <img
        class="banner__img"
        src="@/assets/banner-logo.png"
        alt="banner-logo"
      />
      <p class="banner__text">Invision360 QHA (Quality Health Advice) Tool</p>
      <div class="logout" @click="logout">
        <i class="fas fa-sign-out-alt fa-2x"></i>
      </div>
    </div>
    <div class="main">
      <SideBar />
      <!-- @click="didClickSideBar" /> -->
      <span class="vertical-rule"></span>
      <TopNav />
      <!-- @click="didClickSideBar" /> -->
      <div class="content-container">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import SideBar from '@/components/Reports/Nav/SideBar.vue'
import TopNav from '@/components/Nav/TopNav.vue'
import Footer from '@/components/Footer.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Dashboard',
  components: { SideBar, TopNav, Footer },
  methods: {
    ...mapActions({ _logout: 'user/logout' }),
    logout() {
      this._logout()
      return this.$router.push('/login')
    },
    didClickSideBar(event) {
      console.log({ event })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/dashboard.scss";
</style>
